/**
 * Lambda function configuration for direct Lambda invocation.
 * 
 * These function names correspond to the deployed Lambda functions:
 * - StrandsAgents: Orchestrator Lambda containing UserInputAgent, KBAgent, and G2S2RecordAgent
 * - SlackWebhookFunction: Handles Slack submissions after verification
 * - G2S2HelperFunction: Performs G2S2 record operations
 * 
 * Requirements: 1.1, 1.2, 1.3
 */

export interface LambdaConfig {
  /** StrandsAgents Lambda function name (us-west-2) */
  strandsAgentsFunctionName: string;
  /** SlackWebhookFunction Lambda function name (us-west-2) */
  slackWebhookFunctionName: string;
  /** G2S2HelperFunction Lambda function name (us-east-1) */
  g2s2HelperFunctionName: string;
  /** AWS region for StrandsAgents and SlackWebhook Lambdas */
  usWest2Region: string;
  /** AWS region for G2S2Helper Lambda */
  usEast1Region: string;
}

/**
 * Default Lambda configuration.
 * Function names can be overridden via environment variables if needed.
 */
export const lambdaConfig: LambdaConfig = {
  strandsAgentsFunctionName: process.env.REACT_APP_STRANDS_AGENTS_FUNCTION_NAME || 'StrandsAgents',
  slackWebhookFunctionName: process.env.REACT_APP_SLACK_WEBHOOK_FUNCTION_NAME || 'SlackWebhookFunction',
  g2s2HelperFunctionName: process.env.REACT_APP_G2S2_HELPER_FUNCTION_NAME || 'G2S2HelperFunction',
  usWest2Region: 'us-west-2',
  usEast1Region: 'us-east-1',
};

export default lambdaConfig;
